import { IApplicationState } from '../../types/redux';

export function selectIsCpdAvailableForCurrentRegion(state: IApplicationState): boolean {
  return Boolean(state.cpd?.isAvailableForCurrentRegion);
}
